import { TutorialSlide as TutorialSlideType } from "./tutorialDefinitions";
import { cn } from "@/lib/utils";

interface TutorialSlideProps {
  slide: TutorialSlideType;
  isActive: boolean;
}

export const TutorialSlide = ({ slide, isActive }: TutorialSlideProps) => {
  const IconComponent = slide.icon;

  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center text-center px-6 py-8 transition-all duration-500",
        isActive ? "animate-fade-in opacity-100" : "opacity-0 absolute inset-0 pointer-events-none"
      )}
    >
      {/* Animated Icon */}
      <div className={cn(
        "w-24 h-24 rounded-full flex items-center justify-center mb-8 bg-white/10 animate-scale-in",
        isActive && "animate-pulse"
      )}>
        <IconComponent className={cn("w-12 h-12", slide.iconColor)} />
      </div>

      {/* Title */}
      <h2 className="text-2xl font-bold text-accent mb-4">
        {slide.title}
      </h2>

      {/* Content */}
      <p className="text-white/90 text-lg leading-relaxed max-w-md">
        {slide.content}
      </p>
    </div>
  );
};
